var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "audit-container" },
    [
      _vm.onlyRenderOneAudit
        ? _c("div", [
            _vm.onlyOneAuditId
              ? _c(
                  "div",
                  {
                    staticClass: "audit-grid-item",
                    on: {
                      click: function ($event) {
                        return _vm.downloadAudit(_vm.onlyOneAuditId)
                      },
                    },
                  },
                  [
                    _c("span", { class: [_vm.downloadIcon, "download-icon"] }),
                    _c("span", [_vm._v(_vm._s(_vm.texts.download))]),
                  ]
                )
              : _c("span", { staticClass: "not-available" }, [
                  _vm._v(_vm._s(_vm.texts.notAvailable)),
                ]),
          ])
        : _c(
            "ul",
            { staticClass: "audits" },
            _vm._l(_vm.recipients, function (recipient) {
              return _c("li", [
                recipient.idDocumentAudit
                  ? _c(
                      "div",
                      {
                        staticClass: "audit-grid-item",
                        on: {
                          click: function ($event) {
                            return _vm.downloadAudit(recipient.idDocumentAudit)
                          },
                        },
                      },
                      [
                        _c("span", {
                          class: [_vm.downloadIcon, "download-icon"],
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.texts.download))]),
                      ]
                    )
                  : _c("span", { staticClass: "not-available" }, [
                      _vm._v(_vm._s(_vm.texts.notAvailable)),
                    ]),
              ])
            }),
            0
          ),
      _c("OpenFileComponent", { ref: "openFileComponent" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }